import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { apiEndpointURL } from '@core/constants/endpoints-url';
import { Utilities } from '@core/utils/utilities';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DepartmentService {
  userId: any = this.util.getStoredUserDetails().userId ?? '';

  constructor(private httpClient: HttpClient, private util: Utilities) { }

  getDepartmentListingPageDetails(institutionId: any, pageNumber: any, status?: string, sortBy?: any, sortOrder?: any, deptSrchFilter?: any, from?: string) {
    let params = new HttpParams().set('pageNumber', pageNumber);
    if (status)
      params = params.set('pageSize', 1000).set('parentDepartmentStatus', status);
    else
      params = params.set('pageSize', this.util.recordsPerPage());
    if (sortBy)
      params = params.set('sortBy', sortBy);
    if (sortOrder === 'desc')
      params = params.set('sortOrder', sortOrder);
    if (deptSrchFilter)
      Object.keys(deptSrchFilter).forEach((data) => {
        params = params.set(data, deptSrchFilter[data])
      });
    if (from === 'resolver') params = params.set('resolver', true);
    const deptListingUrl = apiEndpointURL.campusDataEndpoint + institutionId + "/departments";
    return this.httpClient.get(deptListingUrl, { params });
  }

  archiveOrUnarchiveDepartment(institutionId: any, deparmentId: any, status: string) {
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "departments", deparmentId, status].join('/');
    let bodyContent: any = null;
    if (this.userId)
      bodyContent = { updatedBy: Number(this.userId) };
    return this.httpClient.patch(url, bodyContent);
  }

  getDeptmentType(): Observable<any> {
    return this.httpClient.get(apiEndpointURL.departmentTypeEndpoint);
  }

  getDepartmentJSON(): Observable<any> {
    const params = new HttpParams().set('headerNotRequired', true);
    return this.httpClient.get(apiEndpointURL.departmentFieldJson, { params });
  }

  getDepartmentDetails(institutionId: any, departmentId: any, from?: string): Observable<any> {
    let params = new HttpParams();
    if (from === 'resolver') params = params.set('resolver', 'true');
    const deptUrl = apiEndpointURL.getInstitutionEndpoint + '/' + institutionId + '/departments/' + departmentId;
    return this.httpClient.get(deptUrl, { params });
  }

  saveDepartmentDetails(institutionId: any, departmentData: any, departmentId?: any): Observable<any> {
    let saveDeptUrl = apiEndpointURL.getInstitutionEndpoint + '/' + institutionId + '/departments';
    if (departmentId) {
      saveDeptUrl += ('/' + departmentId);
      return this.httpClient.put(saveDeptUrl, departmentData);
    } else {
      return this.httpClient.post(saveDeptUrl, departmentData);
    }
  }

  getAjaxReferenceData(institutionId: any, filterBy: any) {
    const params = new HttpParams().set("filterBy", filterBy);
    const url = [apiEndpointURL.getInstitutionEndpoint, institutionId, "departments/filterData"].join('/');
    return this.httpClient.get(url, { params });
  }
}
